import { cimAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { cimAPIUrls } from '../data';

type Return = {
  authUrl: string;
};

type Params = 'ADE' | 'XPM';

export type getDisconnect = {
  return: Return;
};

export const getDisconnect = withLogger(
  async (type: Params): Promise<Return> => {
    const response = await cimAxiosClient.get<Promise<Return>>(
      type === 'ADE' ? cimAPIUrls.adeDisconnect : cimAPIUrls.xpmDisconnect,
    );

    return response.data;
  },
);
